import { z } from "zod";
import { bookRoleSchema, ulidSchema } from "./schemas.js";
// This is a collaboration-facing responsibility, not an authorization grant.
// Services must continue to authorize requests with the member's BookRole.
export const collaborationRoleSchema = z.enum([
    "OWNER",
    "STORYTELLER",
    "EDITOR",
    "CONTRIBUTOR",
    "VIEWER",
]);
export const contributionStatusSchema = z.enum([
    "NOT_STARTED",
    "IN_PROGRESS",
    "SUBMITTED",
    "APPROVED",
]);
export const collaborationMemberSchema = z
    .object({
    memberId: ulidSchema,
    displayName: z.string().trim().min(1).max(100),
    role: collaborationRoleSchema,
    contributionStatus: contributionStatusSchema,
    joinedAt: z.string().datetime(),
})
    .strict();
export const collaborationInvitationSchema = z
    .object({
    invitationId: ulidSchema,
    role: collaborationRoleSchema.exclude(["OWNER"]),
    state: z.enum(["PENDING", "ACCEPTED", "DECLINED", "EXPIRED", "REVOKED"]),
    createdAt: z.string().datetime(),
    expiresAt: z.string().datetime(),
})
    .strict();
export const collaborationActivityKindSchema = z.enum([
    "INVITATION_CREATED",
    "MEMBER_JOINED",
    "CHAPTER_STARTED",
    "CHAPTER_SUBMITTED",
    "CHAPTER_APPROVED",
    "PREVIEW_READY",
]);
// Deliberately content-free: activity may identify records, never story text or media.
export const collaborationActivitySchema = z
    .object({
    activityId: ulidSchema,
    kind: collaborationActivityKindSchema,
    actorMemberId: ulidSchema.nullable(),
    chapterId: ulidSchema.nullable(),
    occurredAt: z.string().datetime(),
})
    .strict();
export const collaborationPageInfoSchema = z
    .object({
    nextCursor: z.string().trim().min(1).max(512).nullable(),
    hasMore: z.boolean(),
})
    .strict()
    .superRefine((value, context) => {
    if (value.hasMore !== (value.nextCursor !== null))
        context.addIssue({
            code: "custom",
            path: ["nextCursor"],
            message: "nextCursor must be present exactly when hasMore is true.",
        });
});
export const collaborationPageQuerySchema = z
    .object({
    cursor: z.string().trim().min(1).max(512).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
})
    .strict();
export const collaborationMemberPageSchema = z
    .object({
    items: z.array(collaborationMemberSchema).max(100),
    page: collaborationPageInfoSchema,
})
    .strict();
export const collaborationInvitationPageSchema = z
    .object({
    items: z.array(collaborationInvitationSchema).max(100),
    page: collaborationPageInfoSchema,
})
    .strict();
export const collaborationActivityPageSchema = z
    .object({
    items: z.array(collaborationActivitySchema).max(100),
    page: collaborationPageInfoSchema,
})
    .strict();
export const collaborationWorkspaceSchema = z
    .object({
    bookId: ulidSchema,
    viewerRole: bookRoleSchema,
    members: collaborationMemberPageSchema,
    invitations: collaborationInvitationPageSchema,
    activity: collaborationActivityPageSchema,
})
    .strict();
export const collaborationWorkspaceResponseSchema = z
    .object({ data: collaborationWorkspaceSchema })
    .strict();
//# sourceMappingURL=collaboration.js.map